import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-8 text-center" }
const _hoisted_2 = { class: "text-[1.8rem] font-bold text-[#0f1f2e] mb-2" }
const _hoisted_3 = { class: "text-[1.4rem] text-[#627282] mb-7" }
const _hoisted_4 = { class: "flex gap-3 justify-center" }
const _hoisted_5 = ["disabled"]

import type { Group } from "@/types/domain";
import { useLiveGroups } from "@/components/companionGroups/useLiveGroups";
import PopUp from "@/components/popup/PopUp.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LeaveConfirmDialog',
  props: {
    isOpen: { type: Boolean },
    group: {},
    isLeavingGroup: { type: Boolean }
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const { t } = useLiveGroups(
  { _skipInit: true },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  (_e: any, ..._args: any[]) => {},
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopUp, {
    "model-value": __props.isOpen,
    size: "sm",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = v => !v && emit('cancel'))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4" }, [
          _createElementVNode("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "#ef4444",
            "stroke-width": "2.5",
            "stroke-linecap": "round"
          }, [
            _createElementVNode("path", { d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" })
          ])
        ], -1)),
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)("leaveConfirmTitle")), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("leaveConfirm")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "px-[2.4rem] py-[1rem] rounded-[10rem] border border-black/15 text-[#0f1f2e] text-[1.4rem] font-semibold hover:bg-slate-50 transition",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
          }, _toDisplayString(_unref(t)("cancel")), 1),
          _createElementVNode("button", {
            class: "px-[2.4rem] py-[1rem] rounded-[10rem] bg-red-500 text-white text-[1.4rem] font-semibold hover:opacity-85 transition disabled:opacity-40",
            disabled: __props.isLeavingGroup,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
          }, _toDisplayString(_unref(t)("leaveConfirmBtn")), 9, _hoisted_5)
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})